import { Loadable } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspace } from '@/features/workspaces/hooks';
import { PageLayout } from '@/global/components';
import { BreadcrumbItem, Breadcrumbs } from '@/lib/Breadcrumbs';
import { useGetUnifiedProfileQuery } from '@/services/endpoints/unifiedProfiles';
import { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { UnifiedProfileDataTab } from './UnifiedProfileDataTab';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'unifiedProfile:unifiedProfiles',
    path: RouteConstants.unifiedProfiles,
  },
  {
    label: 'unifiedProfile:profileOverview',
  },
];

export const UnifiedProfileDetails: FC = () => {
  const history = useHistory();

  const { id: unifiedProfileId } = useParams<{ id: string }>();
  const workspace = useWorkspace();

  const { isFetching, isUninitialized, isError } = useGetUnifiedProfileQuery({
    unifiedProfileId,
    workspaceId: workspace.id,
  });

  useEffect(() => {
    if (isError) {
      history.push(RouteConstants.defaultRoute);
    }
  }, [isError]);

  return (
    <PageLayout className='gap-4'>
      <header className='grid gap-4'>
        <Breadcrumbs className='border-0 pb-0' items={breadcrumbs} />
      </header>
      <Loadable isLoading={isFetching || isUninitialized}>
        <UnifiedProfileDataTab />
      </Loadable>
    </PageLayout>
  );
};
